import React, { useContext, useState } from "react";
import { Container, Typography, Button, Box, CssBaseline } from "@mui/material";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers";
import AddAvailableTimeModal from "./AvailableTimes/AddAvailableTimeModal";
import AvailableTimesList from "./AvailableTimes/AvailableTimesList";
import BookingsList from "./Bookings/BookingsList";
import { BookingDataContext } from "./useBookingData";

const BookingManagerUI = () => {
    const [isAddModalOpen, setIsAddModalOpen] = useState(false);

    const {
        availableTimes,
        showAvailableTimes,
        setShowAvailableTimes,
        bookingsWithTimes,
        isLoadingBooking,
        fetchBookingsWithAvailableTimes,
        handleSaveAvailableTime,
        fetchAvailableTimes,
    } = useContext(BookingDataContext);

    return (
        <LocalizationProvider dateAdapter={AdapterDateFns}>
            {/* CssBaseline resets the padding and margin for consistent layout */}
            <CssBaseline />
            {/* Using Box to fill the screen width */}
            <Box sx={{ p: 4 }}>
                <Typography variant="h4" gutterBottom component="div">
                    Booking Manager
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => {
                        if (!showAvailableTimes) {
                            fetchAvailableTimes(); // Ensures API is called when showing the list
                        }
                        setShowAvailableTimes(!showAvailableTimes);
                    }}
                    sx={{ mb: 2 }}
                >
                    {showAvailableTimes
                        ? "Hide Available Times"
                        : "Show Available Times"}
                </Button>
                <Button
                    variant="contained"
                    onClick={fetchBookingsWithAvailableTimes}
                    disabled={isLoadingBooking}
                    sx={{ mx: 2, mb: 2 }}
                >
                    {isLoadingBooking
                        ? "Loading..."
                        : "Fetch Bookings with Times"}
                </Button>
                <Button
                    variant="contained"
                    onClick={() => setIsAddModalOpen(true)}
                    sx={{ mb: 2 }}
                >
                    Add Available Time
                </Button>

                <AddAvailableTimeModal
                    open={isAddModalOpen}
                    handleClose={() => setIsAddModalOpen(false)}
                    onSave={handleSaveAvailableTime}
                />

                {showAvailableTimes && (
                    <AvailableTimesList availableTimes={availableTimes} />
                )}
                <BookingsList bookingsWithTimes={bookingsWithTimes} />
            </Box>
        </LocalizationProvider>
    );
};

export default BookingManagerUI;
